import React, { useState } from "react";
import { AlertTriangle, FileCheck2, FileWarning } from "lucide-react";
import * as api from "@/lib/api";
import { useData } from "@/hooks/useData";
import { Loader, PageHeader, Segmented, StatCard, TableCard } from "@/components/ui";
import { DocumentExpiryTable } from "@/components/hrms";

export default function DocumentExpiry() {
  const [filter, setFilter] = useState("all");
  const { data } = useData(() => api.dashboard.admin(), []);
  if (!data) return <Loader />;

  const docs = data.documents_expiring;
  const expired = docs.filter((d) => d.status === "Expired");
  const soon = docs.filter((d) => d.status === "Expiring Soon");
  const rows = filter === "all" ? docs : filter === "expired" ? expired : soon;

  return (
    <>
      <div className="grid gap-3 grid-cols-2 lg:grid-cols-3">
        <StatCard label="Expired" value={expired.length} icon={FileWarning} color="red" onClick={() => setFilter("expired")} />
        <StatCard label="Expiring in 30 Days" value={soon.length} icon={AlertTriangle} color="orange" onClick={() => setFilter("soon")} />
        <StatCard label="Documents Tracked" value={data.documents_tracked} sub={`${data.documents_tracked - docs.length} current`} icon={FileCheck2} color="green" className="col-span-2 lg:col-span-1" />
      </div>

      <PageHeader description="Emirates ID, visa, passport, labour card and insurance renewals due within 30 days." />

      <Segmented
        value={filter}
        onChange={setFilter}
        options={[
          { value: "all", label: "All", count: docs.length },
          { value: "expired", label: "Expired", count: expired.length, tone: "red" },
          { value: "soon", label: "Expiring soon", count: soon.length, tone: "orange" },
        ]}
      />

      <TableCard heading={`${rows.length} renewal${rows.length === 1 ? "" : "s"} needing action`}>
        <DocumentExpiryTable documents={rows} />
      </TableCard>
    </>
  );
}
